export default __webpack_public_path__ + "static/media/moneyTransfer.47dce55f.png";